import React, {useState, useEffect}  from 'react';
import {connect} from 'react-redux';
import {Actions as LOGINACTIONS} from '../../store/actions/authenticationActions';
import Select from 'react-select';
import passwordValidator from 'password-validator';
import BuddyFace from '../../assets/images/buddy-face.png';

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
.is().min(8)                                    // Minimum length 8
.is().max(100)                                  // Maximum length 100
.has().uppercase()                              // Must have uppercase letters
.has().lowercase()                              // Must have lowercase letters
.has().digits(1)                                // Must have at least 1 digits
.has().not().spaces()                           // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values


// // Validate against a password string
// console.log(schema.validate('validPASS123'));
// // => true
// console.log(schema.validate('invalidPASS'));
// // => false

// // Get a full list of rules which failed
// console.log(schema.validate('joke', { list: true }));
// // => [ 'min', 'uppercase', 'digits' ]
const SetPassword = ({
	currentAgreement,
	myAgreements,
	myUpdateCurrentAgreement,
	updateCurrentDepartment,
	currentDepartment,
	departments,
	switchMode,
	mode,
	savePassword,
	validateCode,
	validatingCode,
	recoveryCodeError,
}) => {

	useEffect(() => {
		validateCode()
	},[]);

  	const [username, setUsername] = useState();
  	const [password, setPassword] = useState();
  	const [passwordValidation, setPasswordValidation] = useState(false);
  	const [confirmPassword, setConfirmPassword] = useState();

  	const renderSwitch = (param) => {
	  switch(param) {
	    case 'min':
	      return 'Minimum of 8 characters';
	    case 'lowercase':
	      return 'Missing 1 lowecase character';
	    case 'uppercase':
	      return 'Missing 1 uppercase character';
	    case 'symbols':
	      return 'Missing 1 symbol';
	    case 'digits':
	      return 'Missing 1 digit / number';
	    case 'notEqual':
	      return 'Your passwords do not match';
	  }
	}

	if(recoveryCodeError) {
		return (

			<div className="holder">
				<div className="grid justify-center grid-cols-1" id="login" style={{ height: "100vh" }}>
					<div className="w-1/4 m-auto">
						<div className="text-center">
							<img className="mx-auto h-16" src={BuddyFace}/>
						</div>
						<form className="js-validation-login form-horizontal mt-6 novalidate" method="post">

							<h5 className="text-center font-bold">{recoveryCodeError}</h5>

							<div className="form-group mt-6 text-center">
								<div className="col-xs-12">
								<button className="bg-orange-500 hover:bg-orange-400 text-white font-semibold text-sm py-2 px-5 rounded-sm" type="submit" 
									onClick={(e) => {
										e.preventDefault()
										e.stopPropagation()
										window.location.href = "/login"
								}}>Send me another email</button>
								</div>
							</div>
						</form>
					</div>
			  </div>
			</div>
		)
	}

	return(
		<div className="holder">
	      <div className="grid justify-center grid-cols-1" id="login" style={{ height: "100vh" }}>
	        <form className="js-validation-login m-auto form-horizontal novalidate text-center w-1/4" method="post">
				<div className="text-center">
				<img className="h-16 mx-auto" src={BuddyFace}/>
				</div>

	          <div className="form-group pt-8">

	            {/*<div className="col-xs-12">
	            	              <div className={`form-material form-material-primary floating ${username ? "open" : ""}`}>
	            	                <input className="form-control" type="text" id="login-username" onChange={(e) => setUsername(e.target.value)}/>
	            	                  <label htmlFor="login-username">Email</label>
	            	                
	            	              </div>
	            	            </div>*/}

	            <div className="col-span-6">
	              <div className={`form-material form-material-primary floating${password ? " open" : ""}`}>
				  	<label className="text-sm font-semibold float-left" htmlFor="login-password">Password</label>
					<div className="clearfix" />
	                <input className="px-0 h-8 w-full focus:ring-0 border-l-0 border-r-0 border-t-0 border-b-1 border-gray-300" type="password" id="login-password" onChange={(e) => setPassword(e.target.value)}/>
	                
	              </div>
	            </div>
	            <div className="col-span-6 pt-2">
	              <div className={`form-material form-material-primary floating${confirmPassword ? " open" : ""}`}>
				  	<label className="text-sm font-semibold float-left" htmlFor="confirm-password">Confirm Password</label>
					<div className="clearfix" />
	                <input className="px-0 h-8 w-full focus:ring-0 border-l-0 border-r-0 border-t-0 border-b-1 border-gray-300" type="password" id="confirm-password" onChange={(e) => setConfirmPassword(e.target.value)}/>
	              </div>
	            </div>
	            {
	            	passwordValidation && passwordValidation.length == 1 && passwordValidation[0] == "notEqual" &&
		            <div className="col-xs-12 alert-danger alert">
		            	<h5 style={{
		            		textAlign: "left",

		            	}}>Your passwords do not match.</h5>
		            </div>
		        }
	            {
	            	passwordValidation && passwordValidation.length > 0 && passwordValidation[0] != "notEqual" &&
		            <div className="col-xs-12 alert-danger alert">
		            	<h5 style={{
		            		textAlign: "left",

		            	}}>Your password must have at least.</h5>
		              <ul style={{
					    listStyle: "disc",
					    paddingLeft: "20px",
					    textAlign: "left",
		              }}>
		              	<li>8 characters long</li>
						<li>1 uppercase &amp; 1 lowercase character</li>
						<li>1 number</li>
		              	{/*
		              		passwordValidation.map(error => <li>{renderSwitch(error)}</li>)
		              	*/}
		              </ul>
		            </div>
		        }
	          </div>
	          <div className="form-group">
	            <div className="col-xs-12 mt-6">
	              <button className="bg-orange-500 hover:bg-orange-400 text-white font-semibold text-sm py-2 w-full rounded-sm" type="submit" onClick={(e) => {
	              	e.preventDefault();
	              	e.stopPropagation();
	              	const errors = schema.validate(password, { list: true })
	              	if(errors.length > 0) {
	              		setPasswordValidation(errors);
	              	} else {
		              	if(password == confirmPassword) {
		              		savePassword(username,password,confirmPassword)
		              	} else {
		              		console.log('notTheSame')
		              		setPasswordValidation(['notEqual']);
		              	}
	              	}
	              }}>Save New Password</button>
	            </div>
	          </div>
	        </form>
	      </div>
	    </div>
	)
}




const mapStateToProps = (state) => {
  console.log('state',state && state.my)

  return {
  	profile: state.my.profile,
  	validatingCode: state.authentication.validatingCode,
	recoveryCodeError: state.authentication.recoveryCodeError,
  }
}

const mapDispatchToProps = dispatch => ({
  validateCode: () => dispatch(LOGINACTIONS.validateCode()),
  savePassword: (email,password,confirmPassword) => dispatch(LOGINACTIONS.setPassword(email,password,confirmPassword)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetPassword) 
